import React, { PropsWithChildren, createContext, useContext, useEffect, useState } from 'react';
import moment from 'moment';
import API from '../API';
import { TokenData, UserSession } from '../Classes';

type UserContextType ={
	login: boolean;
	user: UserSession['user'] | null;
	logout: () => void;
};

const UserContext = createContext<UserContextType>({
	login: false,
	user: null,
	logout: () => undefined,
});

var UserProvider = ({ children }: PropsWithChildren)=>{
	var [user, setUser] = useState<UserSession | null>(JSON.parse(localStorage.getItem('team_hr_user_data') || null));
	var [token, setToken] = useState<TokenData | null>(JSON.parse(localStorage.getItem('team_hr_access_token') || null));

	var is_expired = !token || (token.expires <= (moment().unix() + 30));

	var updateData =()=>{
		try{
			setToken(JSON.parse(localStorage.getItem('team_hr_access_token')));
		}catch{}
		try{
			setUser(JSON.parse(localStorage.getItem('team_hr_user_data')));
		}catch{}
	};

	var updateToken =()=>{
		try{
			setToken(JSON.parse(localStorage.getItem('team_hr_access_token')));
		}catch{}
	};

	var logout =()=>{
		API.logout();
	};

	useEffect(()=>{
		window.addEventListener('team_hr_user_data', updateData);
		window.addEventListener('team_hr_user_token', updateToken);
		window.addEventListener('team_hr_user_logout', updateData);

		if(API.getToken()) API.getLogin(true);

		return ()=>{
			window.removeEventListener('team_hr_user_data', updateData);
			window.removeEventListener('team_hr_user_token', updateToken);
			window.removeEventListener('team_hr_user_logout', updateData);
		};
	}, []);

	return <UserContext.Provider value={{
		login: !is_expired && !!user,
		user: is_expired ? null : user?.user || null,
		logout,
	}}>
		{children}
	</UserContext.Provider>;
};

var useUser =()=> useContext(UserContext);

export {
	useUser,
	UserProvider,
};
